import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';

export function SubmitButton({ label, variant = 'primary', className }) {
  const { t } = useTranslation();
  const { isValid, isSubmitting } = useFormState();
  return (
    <Button
      type="submit"
      variant={variant}
      disabled={!isValid || isSubmitting}
      className={className}
    >
      {isSubmitting ? 'Loading ...' : (label ?? t('continue'))}
    </Button>
  );
}
